import { SITE_API_NOTE } from "../../api/config"
import { describeSiteError } from "../../api/http"
import type { OnSiteState } from "./useOnSite"

/** Метка «на сайте» одной строкой. Состояние приходит из общего кэша запроса,
 *  поэтому шапка карточки и панель показывают одно и то же и лишнего запроса
 *  в базу сайта не делают. */
export default function OnSiteTag({
	state,
	siteName,
}: {
	state: OnSiteState
	siteName: string
}) {
	if (state.checking) {
		return (
			<span className="tag tag--muted">
				<span className="spinner" /> {siteName}
			</span>
		)
	}

	if (state.empty) {
		return (
			<span className="tag tag--muted" title="Спрашивать нечего: группа пустая">
				на сайте: нет товаров
			</span>
		)
	}

	if (state.blocked) {
		return (
			<span className="tag tag--muted" title={SITE_API_NOTE}>
				сайт: проверка выключена
			</span>
		)
	}

	if (state.error) {
		return (
			<button
				type="button"
				className="tag tag--muted tag--action"
				title={describeSiteError(state.error)}
				onClick={state.check}
			>
				сайт: ошибка
			</button>
		)
	}

	if (state.isOnSite === undefined) {
		return (
			<button
				type="button"
				className="tag tag--muted tag--action"
				title={`Есть ли группа на ${siteName} — спросить рижский узел`}
				onClick={state.check}
			>
				на сайте: проверить
			</button>
		)
	}

	return (
		<span
			className={"tag " + (state.isOnSite ? "tag--own" : "tag--muted")}
			title={siteName}
		>
			{state.isOnSite ? "на сайте" : "не на сайте"}
		</span>
	)
}
